export default __webpack_public_path__ + "static/media/trash.df4c9d65.svg";